import React from 'react';
import { motion } from 'framer-motion';
interface FadeInSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export const FadeInSection: React.FC<FadeInSectionProps> = ({
  children,
  className = '',
  id
}) => {
  return <motion.section id={id} className={className} initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-67">
      {children}
    </motion.section>;
};